import React, { useEffect, useState } from "react"
import { Spin } from "antd"
import { GET } from "../../utils/apis"
import { secureApi } from "../../Config/api"

// Public privacy policy page for Google OAuth app verification.
// The content of Elmec's iubenda policy (ID 20670992) is fetched through our
// backend (which extracts the document body from the iubenda page) and
// rendered natively here — no iframe/embed.
const IUBENDA_POLICY_URL = "https://www.iubenda.com/privacy-policy/20670992"

const ElmecPrivacyPolicy = () => {
  const [html, setHtml] = useState("")
  const [loading, setLoading] = useState(true)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        // API responses are JWT-encoded; secureApi decodes them for us.
        const response = await secureApi.get(GET.IUBENDA_PRIVACY_POLICY)
        if (response?.success && response?.html) {
          setHtml(response.html)
        } else {
          setFailed(true)
        }
      } catch (error) {
        console.error("Privacy policy load error:", error)
        setFailed(true)
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [])

  return (
    <div
      style={{
        maxWidth: 900,
        margin: "0 auto",
        padding: "32px 20px",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      }}
    >
      {loading && (
        <div style={{ textAlign: "center", padding: "64px 0" }}>
          <Spin size="large" />
        </div>
      )}

      {!loading && failed && (
        <p>
          The privacy policy could not be loaded here. You can read it directly
          at{" "}
          <a href={IUBENDA_POLICY_URL} target="_blank" rel="noreferrer">
            {IUBENDA_POLICY_URL}
          </a>
          .
        </p>
      )}

      {/* Server-side extracted, scripts stripped before it reaches us. */}
      {!loading && !failed && (
        <div
          className="elmec-privacy-policy-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </div>
  )
}

export default ElmecPrivacyPolicy
